import { INTEGRATIONS } from './integrations'

// Uppercase-keyed chip colors map. Derived from the integration registry so
// the values stay in sync. Kept for back-compat with non-modal call sites that
// look up by source.toUpperCase().
export const ACTIVITY_SOURCE_CHIP_COLORS: Record<string, string> = Object.fromEntries(
    Object.values(INTEGRATIONS).map((i) => [i.code.toUpperCase(), i.chipColor])
)
